import SkillGroupRegexes from "../../_shared/regex";
import GETSkillGroupChildrenOperation from "./GET";

namespace SkillGroupChildrenAPISpecs {
  export import Patterns = SkillGroupRegexes;
  export import GET = GETSkillGroupChildrenOperation;
}

export default SkillGroupChildrenAPISpecs;
